<template>
  <div class="big">
    <div class="page_title">系统用户列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <el-button type="primary"
                     style="width: 124px; margin-right: 32px"
                     icon="el-icon-plus"
                     @click="AddUser"
                     :disabled="module_id_array[0] ? !module_id_array.includes('7') : false">添加用户</el-button>
          <div style="position: relative;">
            <el-input placeholder="请输入用户名"
                      v-model="user_name"
                      style="width: 300px"
                      @change="search"></el-input>
            <div class="searh_icon"
                 @click="search">
              <i class="el-icon-search"></i>
            </div>
          </div>

          <div>
            <span style="margin:0 10px 0 ">CRM系统权限</span>
            <span>
              <el-radio-group v-model="is_crm"
                              @change="search">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
          </div>

          <!-- 数据平台权限 -->
          <div>
            <span style="margin:0 10px 0 ">数据平台权限</span>
            <span>
              <el-radio-group v-model="is_data"
                              @change="search">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
          </div>

        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column prop="user_name"
                             label="用户名"></el-table-column>
            <el-table-column prop="group_name"
                             label="所属角色"></el-table-column>
            <el-table-column prop="is_data"
                             label="数据权限">
              <template slot-scope="scope">
                <span>{{ scope.row.is_data ==1 ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="desc"
                             label="描述"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.user_status">正常</span>
                <span v-else
                      style="color: #e53528">锁定</span>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="400">
              <template slot-scope="scope">
                <el-button @click="editAdmin(scope.row)"
                           type="text"
                           size="medium"
                           v-if="scope.row.admin_id != 1"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('8') : false
                  ">编辑</el-button>
                <el-button @click="editStatus(scope.row.admin_id, 0)"
                           type="text"
                           size="medium"
                           v-if="scope.row.user_status && scope.row.admin_id != 1"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('11') : false
                  ">锁定</el-button>
                <el-button @click="editStatus(scope.row.admin_id, 1)"
                           type="text"
                           size="medium"
                           v-if="!scope.row.user_status && scope.row.admin_id != 1"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('11') : false
                  ">解锁</el-button>
                <el-button @click="resetPwd(scope.row.admin_id)"
                           type="text"
                           size="medium"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('10') : false
                  ">重置密码</el-button>
                <el-button @click="delUser(scope.row.admin_id)"
                           type="text"
                           size="medium"
                           v-if="scope.row.admin_id != 1"
                           :disabled="
                    module_id_array[0] ? !module_id_array.includes('9') : false
                  ">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin:20px 0"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="title"
               :visible.sync="adduser"
               width="550px"
               :close-on-click-modal="false">
      <div class="myform">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="120px"
                 class="demo-ruleForm">
          <el-form-item label="用户名"
                        prop="user_name">
            <el-input v-model="ruleForm.user_name"></el-input>
          </el-form-item>
          <el-form-item label="密码"
                        prop="pwd"
                        v-if="title == '添加用户'">
            <el-input v-model="ruleForm.pwd"
                      maxlength="15"></el-input>
          </el-form-item>
          <el-form-item label="所属角色"
                        prop="group_id">
            <el-select v-model="ruleForm.group_id"
                       placeholder="请选择角色"
                       class="input"
                       style="width: 380px">
              <el-option :label="role.group_name"
                         :value="role.group_id"
                         v-for="(role, index) in roleList"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="数据平台权限"
                        prop="is_data">
            <span>
              <el-radio-group v-model="ruleForm.is_data">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>

          </el-form-item>

          <el-form-item label="描述"
                        prop="desc">
            <el-input type="textarea"
                      v-model="ruleForm.desc"
                      placeholder="20字以内"
                      maxlength="20"
                      show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="CRM系统权限">
            <span>
              <el-radio-group v-model="ruleForm.is_crm">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>

          </el-form-item>

        </el-form>
      </div>
      <div style="text-align: left; padding: 0 0 20px 120px">
        <span slot="footer"
              class="dialog-footer">
          <el-button type="primary"
                     @click="submit('ruleForm')"
                     style="width: 92px"
                     size="medium">保 存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from '../../../api/system';
import _ from 'lodash';
import platform from '../../../api/platform';
export default {
  data() {
    let checkPwd = (rule, value, callback) => {
      if (value) {
        if (this.level_three == '1') {
          // 等保三级验证
          let reg = new RegExp(
            /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9])).{11,15}$/
          );
          if (!reg.test(value)) {
            return callback(
              new Error(
                '密码须包含至少大写字母、小写字母、特殊符号组成的11-15位密码'
              )
            );
          } else {
            return callback();
          }
        } else {
          let reg = new RegExp(
            /^[A-Za-z0-9`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$/
          );
          if (value.length < 6 || value.length > 10) {
            return callback(new Error('请输入字母数字符号组成的6-10位密码'));
          } else {
            return callback();
          }
          if (!reg.test(value)) {
            return callback(new Error('请输入字母数字符号组成的6-10位密码'));
          } else {
            return callback();
          }
        }
      } else {
        return callback();
      }
    };
    return {
      level_three: '',
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      roleList: [],
      user_name: '',
      is_crm: '',
      is_data: '',
      adduser: false,
      title: '添加用户',
      ruleForm: {
        user_name: '',
        pwd: '',
        group_id: '',
        desc: '',
        is_crm: '',
        is_data: 0
      },
      rules: {
        user_name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: checkPwd, trigger: 'blur' }
        ],
        group_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        is_data: [{ required: true, message: '请选择', trigger: 'change' }]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取用户列表
    getAdminList() {
      let data = {
        is_crm: this.is_crm,
        is_data: this.is_data,
        user_name: this.user_name,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      system.adminList(data).then((res) => {
        if (res.code == 0) {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    //获取角色列表
    getAdminGroup() {
      system
        .getAdminGroupByList()
        .then((res) => {
          if (res.code == 0) {
            this.roleList = res.data.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getAdminList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getAdminList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getAdminList();
    },
    //添加用户按钮
    AddUser() {
      this.title = '添加用户';
      this.ruleForm = {
        user_name: '',
        pwd: '',
        group_id: '',
        desc: '',
        is_crm: 0,
        is_data: 0
      };
      this.adduser = true;
    },
    //添加/编辑 用户
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.title == '添加用户') {
            let adminData = this.ruleForm;
            system
              .addAdmin(adminData)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('添加成功');
                  this.adduser = false;
                  this.getAdminList();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            let editData = this.ruleForm;
            system
              .editAdmin(editData)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('修改成功');
                  this.adduser = false;
                  this.getAdminList();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //编辑用户
    editAdmin(row) {
      this.title = '编辑用户';
      this.ruleForm = {
        user_name: row.user_name,
        group_id: Number(row.group_id),
        desc: row.desc,
        admin_id: row.admin_id,
        is_crm: row.is_crm,
        is_data: row.is_data
      };
      this.adduser = true;
    },
    //锁定或者解锁系统用户
    editStatus(admin_id, status) {
      system
        .editAdminStatus({ admin_id, status })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('成功修改用户状态');
            this.getAdminList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //重置密码
    resetPwd(admin_id) {
      this.$confirm('您确定重置密码为：123456？', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          system
            .editAdminPassword({ admin_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('成功重置密码');
                this.getAdminList();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    //删除
    delUser(admin_id) {
      this.$confirm('您确定删除该账号？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          system
            .delAdmin({ admin_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除账号成功');
                this.getAdminList();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    //获取是否等保三级验证
    getConfig() {
      platform.getConfigList().then((res) => {
        if (res.code == 0) {
          this.level_three = res.data.level_three;
        }
      });
    }
  },

  created() {
    this.getAdminList();
    this.getAdminGroup();
    this.getConfig();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
  text-align: left;
}
</style>